import { render, staticRenderFns } from "./stokListesi.vue?vue&type=template&id=24cd8c05"
import script from "./stokListesi.vue?vue&type=script&lang=js"
export * from "./stokListesi.vue?vue&type=script&lang=js"
import style0 from "./stokListesi.vue?vue&type=style&index=0&id=24cd8c05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports